import React from "react";
export default function TrainingSection({ header, id, children }) {
  return (
    <>
      <h2 className="uk-heading-divider" id={id}>
        {header}
      </h2>
      <div className="uk-child-width-1-2@m uk-width-1-1@s" data-uk-grid="true">
        {children}
      </div>
    </>
  );
}
